// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import "bootstrap"
import * as bootstrap from "bootstrap"
import Swal from 'sweetalert2'
window.Swal = Swal



window.mostrar_animacion = () => {
  document.getElementById("loading-page")?.classList.remove("loading")
}

window.quitar_animacion = () => {
  document.getElementById("loading-page")?.classList.add("loading")
}